export default __webpack_public_path__ + "static/media/deluxe.52989923.jpg";